import type { Generated, Timestamp } from '.'

export enum EEvent {
  Check = 'check',
  Fold = 'fold',
  Bet = 'bet',
  Raise = 'raise',
  Call = 'call',
  AllIn = 'all_in',
  Join = 'join',
  Leave = 'leave',
  Deal = 'deal',
  Win = 'win',
  Connect = 'connect',
  Disconnect = 'disconnect',
}

export type table_events_dist = {
  table_id: string
  user_id: string
  event_date: Timestamp
  event: Generated<EEvent>
  cards: string | null
  community_cards: string | null
  bet: Generated<number>
  hand_number: Generated<number>
  hand_name: string
  bank: Generated<number>
}

export type CH = {
  table_events_dist: table_events_dist
}
